module.exports = __webpack_public_path__ + "img/haxan-photo-min.e8beead2.jpg";